'use strict';
import $ from '@nuskin/nuskinjquery';
import angular from 'angular';
import {UserService} from '@nuskin/ns-account';
import {
    ShopContextService,
    CartService,
    AdrService,
    PaymentType,
    CheckoutApi,
    OrderManager,
    ExternalPaymentService,
    CheckoutModeService,
    PersonalOfferService
} from '@nuskin/ns-shop';
import {
    nuskin,
    AgelocService,
    RunConfigService,
    storage,
    StringService,
    PersonalOfferStorageService,
    SponsorStorageService,
    WaitingRoomService,
    events,
    StoreFrontSponsorStorageService,
    UrlService,
    ShoppingContext
} from '@nuskin/ns-util';
import {getStrings} from '../util/stringUtil';
import ShippingAddressUtil from '../util/shippingAddressUtil';
import {retrieveProductionToggles} from '@nuskin/ns-feature-flags';
import {MySiteRestService} from '@nuskin/my-site-api';
import {getCachedConfigField} from '@nuskin/configuration-sdk';
import {paymentBynderImagesMap} from '@nuskin/app-elements';
import '../app.js';

let affiliation = '';
let veraVuex;
let agelocme;

const isContext = (ctxt) => {
    let context = ShoppingContext.getShoppingContext();
    if (context) {
        context = ShoppingContext.getShoppingContext().context;
    }
    return context === ctxt;
};

switch (true) {
    case isContext(ShoppingContext.PERSONAL_OFFER):
        affiliation = nuskin.storage.metadata.PERSONAL_OFFER.key;
        break;
    case isContext(ShoppingContext.STOREFRONT):
        affiliation = nuskin.storage.metadata.STOREFRONT.key;
        break;
    case isContext(ShoppingContext.SKIN_CONSULT):
        veraVuex = JSON.parse(localStorage.getItem('skin-consultation-vuex-state')) || {};
        agelocme = veraVuex.app ? veraVuex.app.shareLinkData : {};
        if (agelocme.device && agelocme.device === 'ageLocMe') {
            affiliation = 'ageLocMeConsult';
        } else {
            affiliation = nuskin.storage.metadata.SKINCONSULT.key;
        }
        break;
    default:
        affiliation = 'Web Checkout';
        break;
}

angular.module('checkout').controller('OrderConfirmationCtrl',
    ['$scope', '$rootScope', '$http', 'nsADRType',
        async function($scope, $rootScope, $http, nsADRType) {
            const cfg = RunConfigService.getRunConfig();
            $scope.hideVeraDownloadBanner = !getCachedConfigField('showVeraDownloadBanner');
            $scope.hideStelaDownloadBanner = !getCachedConfigField('showStelaDownloadBanner');
            if (window.ReactNativeWebView) {
                $scope.hideHeader = true;
                $scope.hideFooter = true;
                $scope.hideNavBtns = true;
                $scope.hideVeraDownloadBanner = true;
                $scope.hideStelaDownloadBanner = true;
            } else {
                $scope.androidImageUrl = `https://play.google.com/intl/${cfg.language}_${cfg.country.toLowerCase()}/badges/static/images/badges/${cfg.language}_badge_web_generic.png`;
            }
            const body = document.getElementsByTagName('body')[0];
            body.scrollTo(0, 0);
            const subdomain = await MySiteRestService.getCurrentSubdomain();
            const SHIPIMMEDIATE = 'shipImmediate';
            const ORDER = 'order';
            const ADR = 'adrFuture';
            const path = RunConfigService.getBaseUrl().replace('://', '://mysite.').replace('.nuskin.com', '.mynuskin.com');
            const SPONSOR_ID = SponsorStorageService.getSponsor();
            const STOREFRONT_HOME = `${path}/content/nuskin/${cfg.language}_${cfg.country}/mysite/mysite-home.mysite.${subdomain}.html?storeId=${SPONSOR_ID}`;
            let personalOfferLanding = '';
            const isPersonalOffer = nuskin.util.isPersonalOffer();
            if (isPersonalOffer) {
                personalOfferLanding = PersonalOfferStorageService.getPersonalOffer().landingPageURL;
            }

            removeSkinConsultChannel();

            WaitingRoomService.deleteAllQueueTickets();

            $scope.storefrontSponsor = StoreFrontSponsorStorageService.getStoreFrontSponsor();
            const veraData = JSON.parse(localStorage.getItem('skin-consultation-vuex-state')) || {};
            const isCorporateSponsor = veraData.app && veraData.app.isCorporateSponsor;
            const appropriateContext = ShoppingContext.isContext(ShoppingContext.STOREFRONT) ||
                ShoppingContext.isContext(ShoppingContext.SKIN_CONSULT) ||
                ShoppingContext.isContext(ShoppingContext.PERSONAL_OFFER) ||
                ShoppingContext.isContext(ShoppingContext.PRODUCT_OFFER);
            const isMySiteMarket = await CartService.checkIsMySiteSiteEnable();
            $scope.useMySiteFooterAndHeader = !isCorporateSponsor && appropriateContext;
            $scope.storefrontHeaderLogo = $scope.storefrontSponsor && $scope.storefrontSponsor.siteLogo ? $scope.storefrontSponsor.siteLogo : '';
            $scope.featureFlags = {};

            $scope.tdc = await getStrings();

            $scope.contentLoaded = false;
            $scope.runConfig = RunConfigService.getRunConfig();
            $scope.user = UserService.getUser();
            $scope.PaymentType = PaymentType;
            // $scope.editMode = checkoutSetup.editMode;
            // $scope.ownPath = checkoutSetup.ownPath;
            // $scope.adrProgram = checkoutSetup.adrProgram;
            // $scope.bruneiName = checkoutSetup.bruneiName;
            // $scope.indonesiaName = checkoutSetup.indonesiaName;
            // $scope.malaysiaName = checkoutSetup.malaysiaName;
            // $scope.philippinesName = checkoutSetup.philippinesName;
            // $scope.singaporeName = checkoutSetup.singaporeName;
            // $scope.thailandName = checkoutSetup.thailandName;
            $scope.isGuestCheckout = CheckoutModeService.isGuestCheckout();
            $scope.sapItems = CartService.getItemData({sapItems: true});
            $scope.cartProducts = CartService.getItemData();

            // Load the order if we don't have it
            if (!$rootScope.order) {
                $rootScope.order = OrderManager.getCompletedOrder();
            }

            if (!$rootScope.order) {
                // always going to landing page (cart) if the order is empty...
                if (nuskin.util.isMecommerceStoreFront()) {
                    window.location = STOREFRONT_HOME;
                } else {
                    window.location = $scope.runConfig.landing;
                }
                // alert($scope.runConfig.landing);
                return;
            }
            $scope.signup = CartService.getCartProperty('inSignup');
            $scope.scanCards = CartService.getScanCards();
            $scope.adr = AdrService.getAdrDraft();

            $scope.nextOrder = OrderManager.getOrder() && $rootScope.order.adr;
            $scope.nextADROrder = OrderManager.getOrder() && !$rootScope.order.adr;

            $scope.showWebSavings = !$rootScope.order.adr && getCachedConfigField('showWebSavings');
            $scope.webSavings = 0.0;
            $scope.hideNewOrderBtn =
                getCachedConfigField('hideNewOrderButton') ||
                $scope.nextOrder ||
                $scope.nextADROrder ||
                (!$scope.tdc.newOrderText || $scope.tdc.newOrderText.length == 0) || $scope.isGuestCheckout;

            $scope.showPsv = ShopContextService.showPsv($scope.user ? $scope.user.accountType : 0);

            $scope.cuotas = $rootScope.order.selectedPayment.useInstallments ? $rootScope.order.selectedPayment.getInstallmentSelectedNumber() : 1;

            if ($rootScope.order.selectedPayment.useInstallments) {
                $scope.installmentPaymentsOfLabel =
                    $scope.tdc.installmentPaymentsOfLabel ?
                        $scope.tdc.installmentPaymentsOfLabel.replace('{numPayments}', $rootScope.order.selectedPayment.installmentSelectedNumber) :
                        '';
            }

            if (getCachedConfigField('enabled')) {
                $scope.orderLoyaltyEarnings = CartService.calculateLoyaltyEarnings(undefined, true);
            }

            if (getTotalOrderPoints() > 0) {
                AdrService.getAdrPoints({forceRefresh: true})
                    .then((availablePoints) => {
                        $scope.$apply(() => {
                            $scope.user.availablePoints = availablePoints;
                            $scope.usedPoints = getTotalOrderPoints();
                            UserService.setUser($scope.user);
                        });
                    })
                    .catch(console.error);
            }

            retrieveProductionToggles($scope.user.id)
                .then((flags) => {
                    $scope.featureFlags = Array.from(flags)
                        .reduce((a, x) => Object.assign(a, {[x]: true}), {});
                    $scope.$apply();
                })
                .catch(console.error);

            $scope.translations = {
                loyalty: {
                    enjoyCreditsLabel: '',
                    confirmationEarningsLabel: '',
                    confirmationRedeemedLabel: '',
                    confirmationDisclaimer: ''
                }
            };

            $scope.getTranslation = () => {
                angular.forEach($scope.translations, (object, applicationKey) => {
                    StringService.getApplicationStrings(applicationKey).then((response) => {
                        $scope.translations[applicationKey] = response;
                        $scope.$apply();
                    });
                });
            };
            $scope.getTranslation();

            $scope.getConfig = (config) => {
                return getCachedConfigField(config);
            };

            //* ********************************************************************************
            //                              Private Functions
            //* ********************************************************************************

            /**
             * sendAnalyticsData
             */
            function sendAnalyticsData() {
                console.log('Sending analytics data...');
                if (nuskin.newShop) {
                    let orderType = ORDER;

                    if ($rootScope.order.adr && $scope.adr.shipImmediate) {
                        orderType = SHIPIMMEDIATE;
                    } else if ($rootScope.order.adr) {
                        orderType = ADR;
                    }
                    if (!ExternalPaymentService.hasErrorMessageForCheckoutPage()) {
                        const orderNumber = $rootScope.order.orderId || $rootScope.order.externalId;
                        const ecommerceEvent = {
                            'ecommerce': {
                                'currencyCode': $rootScope.order.currencyCode,
                                'purchase': {
                                    'actionField': {
                                        'id': orderNumber, // Transaction ID. Required for purchases and refunds.
                                        'memberid': $rootScope.order.toJSON().soldToMemberId,
                                        'orderType': orderType,
                                        'sponsor_id': SPONSOR_ID || $scope.user.sponsorId,
                                        'origin': affiliation, // Web Checkout or Storefront or Personal Offer
                                        'revenue': $rootScope.order.orderTotals.grandTotal, // Total transaction value (incl. tax and shipping)
                                        'tax': $rootScope.order.orderTotals.tax,
                                        'shipping': $rootScope.order.orderTotals.shipping,
                                        'coupon': $rootScope.order.productDiscountCode
                                    },
                                    'products': CartService.getItemData().map((item) => {
                                        return {
                                            'name': item.title,
                                            'id': item.sku,
                                            'price': item.price,
                                            'promoPrice': item.promoPrice,
                                            'psv': item.psv,
                                            'quantity': item.qty
                                        };
                                    })
                                }
                            }
                        };
                        if (typeof dataLayer != 'undefined') {
                            events.publish(events.shop.CART_CHECKOUT_PURCHASE, ecommerceEvent);
                        }
                    }
                }
            }

            /**
             * defaultLabelValues
             */
            function defaultLabelValues() {
                if (typeof $scope.tdc.scanCardNumber === 'undefined') {
                    $scope.tdc.scanCardNumber = 'Scan Card Number';
                }
                if (typeof $scope.tdc.scanCardUserName === 'undefined') {
                    $scope.tdc.scanCardUserName = 'Scan Card UserName';
                }
            }

            /**
             * Perform post-order cleanup for ADR Override orders in ECC market.
             * In ECC markets, the ADR record must be updated by the client following an
             * ADR Override order.
             * The following updates are made to the ADR:
             *  * Any one-time items are removed
             *  * Any items being redeemed with points are reverted
             */
            async function cleanupECCADROverride() {
                const id = AdrService.getAdrOverrideId();
                const adr = await AdrService.getAdrDetails(id, {forceRefresh: true});

                // Update both one-time and redeemed items
                const oneTimeItems = adr.SalesOrderDetail.LineItemDetails
                    .filter((i) => i.LineItem.PayWithPoints || i.LineItem.OneTime)
                    .map((i) => ({
                        LineID: i.LineItem.LineID,
                        Action: 'DELETE',
                        RequestedQuantity: i.LineItem.RequestedQuantity
                    }));
                // const redeemedItems = adr.SalesOrderDetail.LineItemDetails
                //     .filter((i) => i.LineItem.PayWithPoints && !i.LineItem.OneTime)
                //     .map((i) => ({
                //         LineID: i.LineItem.LineID,
                //         Action: 'UPDATE',
                //         PayWithPoints: false,
                //         RequestedQuantity: i.LineItem.RequestedQuantity
                //     }));
                await AdrService.editAdrItems(id, oneTimeItems);
            }

            /**
             * Skin Consultation (Vera) cleanup & status update
             */
            function removeSkinConsultChannel() {
                if (nuskin.util.isSkinConsult && nuskin.util.isSkinConsult()) {
                    storage.removeItem(storage.metadata.SKINCONSULT);
                    // update status
                    PersonalOfferService.callVeraPurchase(nuskin.util.getSponsorId());
                }
            }

            /**
             * Perform post-order cleanup for ADR one-time orders.
             */
            function cleanupAdrOneTimePointsRedemption() {
                const adrId = AdrService.getAdrOverrideId();

                AdrService.getAdrDetails(adrId)
                    .then((adr) => adr.SalesOrderDetail.LineItemDetails
                    // Remove one-time and pay-with-points items from the ADR
                        .filter((item) => item.LineItem.PayWithPoints || item.LineItem.OneTime)
                    // Item removal request requires line IDs of ADR line items
                        .map((item) => {
                            return {
                                LineID: item.LineID,
                                Action: 'DELETE'
                            };
                        }))
                    .then((itemsToRemove) => {
                        if (itemsToRemove.length > 0) {
                            return AdrService.editAdrItems(adrId, itemsToRemove);
                        }
                    })
                    .catch(console.error);
            }

            /**
             * setWebSavings
             */
            function setWebSavings() {
                const orderTotals = $rootScope.order.orderTotals;
                const tax = orderTotals['taxInclusive'] ? orderTotals['tax'] : 0.0;
                const price = orderTotals['grandTotal']; // price with tax and shipping
                const shipping = orderTotals['shipping'];
                const user = $scope.user;
                const priceType = user.priceType == 'PRF' ? 'WHL' : user.priceType;

                // total of items without savings ... does not include tax or shipping
                const nonWebPrice = CartService.getPriceTypeTotal(priceType);
                const savings = nonWebPrice - (price - tax - shipping);
                $scope.webSavings = savings > 0.0 ? savings : 0.0;
            }

            /**
             * checkForSignup
             */
            function checkForSignup() {
                if ($scope.signup) {
                    $scope.confirmationSpinner = true;
                    $http({
                        method: 'GET',
                        url: getCachedConfigField('accountServiceUrl') + '/extended/' + $scope.user.id + '?eid=' + $scope.user.eid,
                        headers: {
                            'client_id': $scope.runConfig.clientId,
                            'client_secret': $scope.runConfig.clientSecret
                        }
                        // params: { cntryCd: $scope.runConfig.country }
                    }).then(function(response) {
                        $scope.signupDetail = response.data;
                        angular.forEach($scope.signupDetail.BeReadResponse.Contact, function(c) {
                            if (c.Value.Type === 'EMAIL') {
                                $scope.signupDetail.username= c.Value.value;
                            }
                        });
                        $scope.confirmationSpinner = false;
                    }, function() {
                        $scope.confirmationSpinner = false;
                    });
                }
            }

            // If this is a storefront offer we publish the store front order complete event.
            if (nuskin.util.isMecommerceStoreFront()) {
                $scope.isStorefront = true;
                const sponsorData = StoreFrontSponsorStorageService.getStoreFrontSponsor();
                if (sponsorData &&
                    sponsorData.storefront &&
                    sponsorData.storefront[subdomain] &&
                    sponsorData.storefront[subdomain][$scope.runConfig.country]) {
                    const countryData = sponsorData.storefront[subdomain][$scope.runConfig.country];
                    if (countryData.lang && countryData.lang[$scope.runConfig.language]) {
                        $scope.congratsMessage = countryData.lang[$scope.runConfig.language].purchaseMessage;
                    }
                }

                // Hide the shopping bag.
                $('.nav-header-cart').hide();
            }

            sendAnalyticsData();
            // If detect agelocMe Products on cart it will be stored on firebase accoriding to user
            const agelocMeProducts = $scope.cartProducts.filter((product) => product.agelocme);
            if (agelocMeProducts.length > 0) {
                AgelocService.addAssesment($scope.user, agelocMeProducts);
            }

            if ($scope.showWebSavings) {
                setWebSavings();
            }

            defaultLabelValues();
            checkForSignup();

            // if storefront or pitch they will have a sponsor
            if (SponsorStorageService.getSponsor()) {
                const personalOfferObject = PersonalOfferStorageService.getPersonalOffer();
                $scope.isVeraOrder = ShoppingContext.isContext(ShoppingContext.SKIN_CONSULT);
                $scope.isPitchOrder = CartService.getCartProperty('isPitchCart');
                $scope.personalOfferMessage =
                    $scope.isPitchOrder ? personalOfferObject.congratulations : ($scope.isVeraOrder ? veraData.app.shareLinkData.confirmationMessage : null);

                if (personalOfferObject) {
                    $scope.offerCongrats = personalOfferObject.congratulations;
                }
            }

            // Cleanup steps specific to ADR orders
            if (AdrService.isAdrOneTimeOrder()) {
                cleanupAdrOneTimePointsRedemption();
            } else if (AdrService.isAdrOverride() && !getCachedConfigField('isCrmMarket')) {
                cleanupECCADROverride().catch(console.error);
            }

            CheckoutApi.cleanupOrder();

            // Do not let user leave page if another order needs to be processed
            $scope.showNextOrderWarning = false;
            if ($scope.nextOrder || $scope.nextADROrder) {
                // Change state back to display name -- hack for mexico city
                ShippingAddressUtil.mapStateToDisplay($rootScope.order.selectedAddress);
                window.addEventListener('beforeunload', completeNextOrder);
            } else {
                nsADRType.setADRType(nsADRType.NO_SELECTION_TYPE);
            }
            $scope.contentLoaded = true;

            $scope.startNextOrder = function() {
                window.removeEventListener('beforeunload', completeNextOrder);
                CartService.goToCheckoutPage({route: 'orderSummary'});
                // $location.path('/');
            };

            $scope.stateValueName = '';

            //* ************************************************************************
            //                  Scope functions
            //* ************************************************************************

            /**
             * getLineItemClass is just retr
             *
             * @param {object} item
             * @return {string}
            */
            $scope.getLineItemClass = function(item) {
                if (item.isAdr && !item.isBusinessPortfolio) {
                    return 'adrRow';
                }
                return 'noAdrRow';
            };

            $scope.goHome = function() {
                sessionStorage.setItem('appChangeSpinner', true);
                if (nuskin.util.isMecommerceStoreFront()) {
                    window.location = STOREFRONT_HOME;
                } else if (isPersonalOffer) {
                    window.location = personalOfferLanding;
                } else if ($scope.runConfig.alternateHomeUrl && $scope.runConfig.alternateHomeUrl.length > 0) {
                    window.location = $scope.runConfig.alternateHomeUrl;
                    if ($scope.runConfig.addSkusToLandingPage === true) {
                        window.location = CartService.getOrderSkuQueryParams(true);
                    }
                } else {
                    window.location = `${UrlService.getAemLocaleUrl()}home.html`;
                }
            };

            $scope.goToCart = function() {
                if (isMySiteMarket &&
                    (ShoppingContext.isContext(ShoppingContext.STOREFRONT) ||
                    ShoppingContext.isContext(ShoppingContext.SKIN_CONSULT) ||
                    ShoppingContext.isContext(ShoppingContext.PERSONAL_OFFER) ||
                    ShoppingContext.isContext(ShoppingContext.PRODUCT_OFFER))) {
                    // keep mysite in route
                    CartService.goToCartPage({isMySite: true});
                } else {
                    clearContext();
                    CartService.goToCartPage({isMySite: false});
                }
            };


            $scope.printConfirmation = function() {
                window.print();
            };

            $scope.getFormattedCCExpiration = function() {
                let formattedCCExpiration = '';

                if ($rootScope.order && $rootScope.order.selectedPayment &&
            $rootScope.order.selectedPayment.expMonth &&
            $rootScope.order.selectedPayment.expYear) {
                    formattedCCExpiration = $rootScope.order.selectedPayment.expMonth +
                '/' + $rootScope.order.selectedPayment.expYear;
                }

                return formattedCCExpiration;
            };

            $scope.showPendingAuthorization = function() {
                return $rootScope.order.paymentClass === 'CCARD' &&
            ($rootScope.order.paymentStatus === 'PENDING_PAYMENT' ||
                $rootScope.order.paymentStatus === 'PAYMENT_PENDING');
            };

            // payWithPoints logic
            $scope.showPointsBalance = function() {
                return getTotalOrderPoints() > 0;
            };

            // if agelocme product then returns the agelocme code otherwise
            // it returns the sku
            $scope.getItemSkuCodeValue = (dispItem = {sku: ''}) => {
                return dispItem.agelocme ? dispItem.agelocme.code : dispItem.sku;
            };

            $scope.getCardIcon = (id) => {
                return paymentBynderImagesMap[id] || '';
            },

            $scope.numberOfCalls = 0;

            $scope.isWirePayment = function(p) {
                return (p.paymentTypeId === PaymentType.PROV ||
            p.paymentTypeId === PaymentType.PWEB ||
            p.paymentTypeId === PaymentType.WIRE ||
            (p.paymentTypeId >= PaymentType.VIB_WIRE && p.paymentTypeId <= PaymentType.CR));
            };

            $scope.isHidingPaymentIcon = function(p) {
                return (p.paymentTypeId === PaymentType.MPOS ||
            p.paymentTypeId === PaymentType.PROV ||
            p.paymentTypeId === PaymentType.PWEB ||
            (p.paymentTypeId >= PaymentType.VIB_WIRE && p.paymentTypeId <= PaymentType.CR));
            };

            /**
             * Registry that acts as a white list for generic payment validation. This function reduces boilerplate code
             * by providing a generic check for accepted payments for the following functions within the scope of
             * the order confirmation controller:
             *
             * isIncludingTypeDescription
             * isHidingPaymentNumber
             * isHidingExpiration
             * isHidingBoldTypeDescription
             *
             * This function can be abused if it's used improperly. Don't look to this as a registry of
             * accepted payments for every payment scenario. For example, wired payments are limited and
             * only contain a small subset of the payments listed below, so this function should not be called in
             * wired payment checking etc. Some functions (i.e. wired payments) only need to check a couple of
             * paymentTypeId's and don't need to invoke this function.
             *
             * @param {string} paymentTypeId (integer) mapping to the payment type code.
             * @return {boolean} true if paymentTypeId is whitelisted else false.
             */
            function genericPaymentCheck(paymentTypeId) {
                try {
                    switch (paymentTypeId) {
                        case PaymentType.APVN:
                        case PaymentType.BDO:
                        case PaymentType.CIMB:
                        case PaymentType.CITI:
                        case PaymentType.DBS:
                        case PaymentType.HSBC:
                        case PaymentType.KBANK:
                        case PaymentType.KLIK:
                        case PaymentType.MBB:
                        case PaymentType.PBB:
                        case PaymentType.PERMATA:
                        case PaymentType.PWEB:
                        case PaymentType.UOB:
                        case PaymentType.WIRE:
                            return true;
                            // Final check against VIB_WIRE and CR.
                        default:
                            return (paymentTypeId >= PaymentType.VIB_WIRE && paymentTypeId <= PaymentType.CR);
                    }
                } catch (e) {
                    // Safety catch for undefined or null de-referencing in the try block.
                    console.warn('orderConfirmation -> genericPaymentCheck: ' + e.msg);
                    return false;
                }
            }

            $scope.isIncludingTypeDescription = function(p) {
                return (p.paymentTypeId === PaymentType.PROV ||
            genericPaymentCheck(p.paymentTypeId));
            };

            $scope.isHidingPaymentNumber = function(p) {
                return (p.paymentTypeId === PaymentType.IDEA ||
            p.paymentTypeId === PaymentType.PROV ||
            genericPaymentCheck(p.paymentTypeId));
            };

            $scope.isHidingExpiration = function(p) {
                return (p.paymentTypeId === PaymentType.IDEA ||
            p.paymentTypeId === PaymentType.MPOS ||
            p.paymentTypeId === PaymentType.SDD ||
            genericPaymentCheck(p.paymentTypeId));
            };

            $scope.isHidingBoldTypeDescription = function(p) {
                return (p.paymentTypeId === PaymentType.PROV ||
            p.paymentTypeId === PaymentType.SDD ||
            genericPaymentCheck(p.paymentTypeId));
            };

            function clearContext() {
                $scope.useMySiteFooterAndHeader = false;
                PersonalOfferStorageService.clearPersonalOffer();
                StoreFrontSponsorStorageService.clearStoreFrontSponsor();
                SponsorStorageService.clearSponsor();
                ShoppingContext.clearShoppingContext();
            }

            /**
             * getTotalOrderPoints
             *
             * @return {*}
             */
            function getTotalOrderPoints() {
                return CartService.getItemData({cartItems: true})
                    .filter((item) => item.redeem)
                    .map((item) => item.qtyRedeemWithPoints * item.points)
                    .reduce((a, b) => a + b, 0);
            }

            /**
             * completeNextOrder
             *
             * @param {object} e
             */
            function completeNextOrder(e) {
                e.preventDefault();
                e.returnValue = $scope.tdc.nextOrderWarningText;
            }
        }]);
